import React from 'react';
import jwtDecode from 'jwt-decode';

import AuthProvider, { constructUserFromFirebaseUser } from './AuthProvider';
import { K_USER_LEVEL_BANK_ACCOUNT } from '../../shared/constants';
import FreshchatProvider from '../../../common/libs/freshchat/FreshchatProvider';

const parseJwt = token => {
  try {
    return jwtDecode(token);
  } catch (e) {
    return null;
  }
};

export default function wrapAuth(WrappedComponent) {
  const Comp = class extends React.Component<any, any> {
    static async getInitialProps(context) {
      const { client, token } = context;
      const firebaseUser = parseJwt(token);
      context.user = constructUserFromFirebaseUser(firebaseUser);

      try {
        const {
          error,
          payload: { payload: user }
        } = await client.query({
          url: '/v3/user/individual',
          method: 'get'
        });
        if (!error && user) {
          context.user = user;
          context.user.emailVerified = true;
          // context.user.kyc_level = K_USER_LEVEL_BANK_ACCOUNT;
        }
      } catch (error) {
        // console.log(error);
      }

      const initialProps = await ((WrappedComponent.getInitialProps &&
        WrappedComponent.getInitialProps(context)) ||
        {});
      return {
        ...initialProps,
        user: context.user
      };
    }

    render() {
      return (
        <AuthProvider user={this.props.user}>
          <WrappedComponent {...this.props} />
          <FreshchatProvider />
        </AuthProvider>
      );
    }
  };
  return Comp;
}
